import './report-app'



// WEBPACK FOOTER //
// ./src/setup.report.js